import React from 'react';
import './PeopleMap.css';
import { MapClouds } from './MapClouds';

// TEMP: preview page for tuning the intro clouds in their initial (covered)
// state, without the map or the fly-away animation. Route: /clouds
export function CloudsPreview() {
  return (
    <div className="people-map" style={{ height: '100vh', width: '100vw' }}>
      <MapClouds phase="covered" />
    </div>
  );
}

export default CloudsPreview;
